import Vue from 'vue'
import router from './router'
import App from './app.vue'
import MetaInfo from 'vue-meta-info'
import '../../assets/public.css'
import stroage from '../../components/storage'
import bus from '../../components/event-bus'
Vue.prototype.bus = bus;
Vue.prototype.storage = stroage
Vue.use(MetaInfo);
new Vue({
    el: '#app',
    router,
    render: h => h(App)
});